import { BgcVendor, COUNTRY_SHORTCODES } from '../constants'
import { SupportedCountryCode } from '../models/types'

export const getBackgroundCheckVendor = (countryCode: SupportedCountryCode) => {
  const bgcVendorCountryMap = {
    [COUNTRY_SHORTCODES.AU]: BgcVendor.NCC,
    [COUNTRY_SHORTCODES.NZ]: BgcVendor.NCC,
  }

  return bgcVendorCountryMap[countryCode]
}
